// Variables
const $primary = '#08fdd8';

// Import style
import './../../scss/custom/main.scss';

// Start: Oscillator

// Import oscillator function
import { initOciliator } from './../oscillator/oscillator';

let isMobileDevice = false;

// Device detection
if (
  /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(
    navigator.userAgent
  ) ||
  /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
    navigator.userAgent.substr(0, 4)
  )
) {
  isMobileDevice = true;
}

// Hide canvas and do not initiate oscillator effect on mobile devices
if (window.innerWidth > 680 && !isMobileDevice) {
  initOciliator(false);
} else {
  document.querySelector('#home #canvas').style.display = 'none';
}

// End: Oscillator

// Start: Sound

const soundSwitch = document.querySelector('#sound a');

soundSwitch.addEventListener('click', (e) => {
  e.preventDefault();

  const soundPlayState = document.querySelector('#sound');
  const audio = document.querySelector('#background-sound');

  soundPlayState.classList.toggle('active');

  if (soundPlayState.classList.contains('active')) {
    audio.play();
  } else {
    audio.pause();
  }
});

// End: Sound

// Start: Skills sphere

try {
  TagCanvas.Start('skills-canvas', 'skills-tags', {
    textColour: $primary,
    outlineColour: 'transparent',
    depth: 0.8,
    maxSpeed: 0.05,
    weight: true,
    zoomMax: 1.0,
    zoomMin: 1.0,
    initial: [0.2, -0.1],
  });
} catch (e) {
  // something went wrong, hide the canvas container
  document.querySelector('#skills-chart').style.display = 'none';
}

const skillsLinks = document.querySelectorAll('#skills-tags a');

skillsLinks.forEach((element) => {
  element.addEventListener('click', (e) => {
    e.preventDefault();
  });
});

// End: Skills sphere

// Start: Work

const projectLinks = document.querySelectorAll('.project-wall-item a');
const projectOverlay = document.querySelector('#overlay-modal');
const modal = document.querySelector('#project-modal');
const modalClose = document.querySelector('#project-modal .close');

// Start project slide-show
projectLinks.forEach((element) => {
  element.addEventListener('click', (e) => {
    e.preventDefault();

    const project = e.target.dataset.project;

    modal.classList.remove('d-none');
    projectOverlay.classList.remove('d-none');

    modal.querySelectorAll('.slide-wrapper').forEach((element) => {
      element.classList.add('d-none');
    });

    modal.querySelector('.slide-wrapper.' + project).classList.remove('d-none');

    modal
      .querySelectorAll('.slide-wrapper.' + project + ' img')
      .forEach((element) => {
        element.classList.add('d-none');
      });

    modal
      .querySelector('.slide-wrapper.' + project + ' img')
      .classList.remove('d-none');

    modal.querySelector('.current-slide').textContent = '1';
    modal.querySelector('.total-slide').textContent = modal.querySelectorAll(
      '.slide-wrapper.' + project + ' img'
    ).length;
  });
});

// Close project slide-show
modalClose.addEventListener('click', (e) => {
  projectOverlay.classList.add('d-none');
  modal.classList.add('d-none');
});

// Slide-show navigation
const previousButton = modal.querySelector('button#previous');
const nextButton = modal.querySelector('button#next');

previousButton.addEventListener('click', () => {
  const currentSlide = document.querySelector(
    '.slide-wrapper:not(.d-none) img:not(.d-none)'
  );
  const previousSlide = currentSlide.previousElementSibling;

  if (previousSlide) {
    currentSlide.classList.add('d-none');
    previousSlide.classList.remove('d-none');

    let slides = document.querySelectorAll('.slide-wrapper:not(.d-none) img');

    modal.querySelector('.current-slide').textContent =
      Array.prototype.indexOf.call(slides, currentSlide);
  }
});

nextButton.addEventListener('click', () => {
  const currentSlide = document.querySelector(
    '.slide-wrapper:not(.d-none) img:not(.d-none)'
  );
  const nextSlide = currentSlide.nextElementSibling;

  if (nextSlide) {
    currentSlide.classList.add('d-none');
    nextSlide.classList.remove('d-none');

    let slides = document.querySelectorAll('.slide-wrapper:not(.d-none) img');

    modal.querySelector('.current-slide').textContent =
      Array.prototype.indexOf.call(slides, currentSlide) + 2;
  }
});

// End: Work

// Start: Contact

(function () {
  emailjs.init('zQlkKzWPYr4Kt9au_');
})();

const sendMessageButton = document.querySelector('.send-message-button');

sendMessageButton.addEventListener('click', (e) => {
  e.preventDefault();

  if (sendMessageButton.classList.contains('disabled')) {
    return;
  }

  const name = document.querySelector('.contact-form #name');
  const email = document.querySelector('.contact-form #email');
  const subject = document.querySelector('.contact-form #subject');
  const message = document.querySelector('.contact-form #message');

  if (name.value == '') name.parentElement.classList.add('invalid');
  else name.parentElement.classList.remove('invalid');

  if (email.value == '' || !isValidEmail(email.value))
    email.parentElement.classList.add('invalid');
  else email.parentElement.classList.remove('invalid');

  if (subject.value == '') subject.parentElement.classList.add('invalid');
  else subject.parentElement.classList.remove('invalid');

  if (message.value == '') message.parentElement.classList.add('invalid');
  else message.parentElement.classList.remove('invalid');

  if (document.querySelectorAll('.contact-form li.invalid').length == 0) {
    sendMessageButton.classList.add('disabled');
    sendMessageButton.querySelector('.text').innerHTML = 'Sending...';

    sendEmail(name.value, email.value, subject.value, message.value)
      .then((res) => {
        alertify.success('Message sent successfully!');
        sendMessageButton.classList.remove('disabled');
        sendMessageButton.querySelector('.text').innerHTML = 'Send message!';

        // Reset contact form
        document.querySelector('.contact-form form').reset();
      })
      .catch((error) => {
        alertify.error('Something went wrong!');
        sendMessageButton.classList.remove('disabled');
        sendMessageButton.querySelector('.text').innerHTML = 'Send message!';
      });

    return;
  } else {
    alertify.error('Please fill required fields');

    if (email.value != '' && !isValidEmail(email.value)) {
      alertify.error('Please enter valid email');
    }
  }
});

// Validate email
function isValidEmail(email) {
  const regex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
  return regex.test(email);
}

// Send email
const sendEmail = (name, email, subject, message) => {
  return new Promise((resolve, reject) => {
    const parameters = {
      from_name: name,
      from_email: email,
      subject: subject,
      message: message,
    };

    emailjs
      .send('service_7s5t6cw', 'template_i7196zv', parameters)
      .then((res) => resolve(res))
      .catch((error) => reject(error));
  });
};

// End: Contact

// On scroll animations
window.addEventListener('scroll', function () {
  let elements = document.querySelectorAll(
    'section .intro:not(.loaded), section .header h2:not(.loaded), section .project-wall:not(.loaded), section .blog-articles:not(.loaded)'
  );
  let position;

  elements.forEach((element) => {
    if (element) {
      position = element.getBoundingClientRect();

      // Checking whether fully visible
      //if (position.top >= 0 && position.bottom <= window.innerHeight) {}

      // Checking whether partially visible
      if (position.top < window.innerHeight && position.bottom >= 0) {
        element.classList.add('loaded');

        let i = 0;
        let isIntro = false;

        if (element.classList.contains('intro')) {
          isIntro = true;

          setTimeout(() => {
            element.querySelector('.name-initial').classList.add('spin');
          }, 700);
        }

        element.querySelectorAll('.blast').forEach((element) => {
          setTimeout(() => {
            element.classList.add('animate', 'bounce-in');
          }, i);

          if (i == 500 && isIntro) {
            i = i + 100;
          }

          i = i + 100;
        });

        setTimeout(
          () => {
            element.querySelectorAll('.blast').forEach((element) => {
              element.classList.remove('animate', 'bounce-in');
            });

            element.querySelectorAll('.blast').forEach((element) => {
              element.style.opacity = 1;
            });

            element.querySelectorAll('.blast').forEach((element) => {
              element.addEventListener('mouseover', (e) => {
                e.target.classList.add('animate', 'rubber-band');
              });

              element.addEventListener('animationend', (e) => {
                e.target.classList.remove('animate', 'rubber-band');
              });
            });
          },
          isIntro ? 4000 : 2000
        );

        i = 0;

        element.querySelectorAll('.project-wall-item').forEach((element) => {
          setTimeout(() => {
            element.classList.add('fade-in-left');
          }, i);

          i = i + 150;
        });

        i = 0;

        element.querySelectorAll('.post-article').forEach((element) => {
          setTimeout(() => {
            element.classList.add('fade-in-up');
          }, i);

          i = i + 150;
        });

        if (element.closest('section').id == 'contact') {
          alertify.message('Have any question? Drop me a mail...');
        }
      }
    }
  });
});

// Manually trigger scroll event on page load
window.dispatchEvent(new Event('scroll'));
